const getBookingSubdomain = () => {

  const hostname =
    window.location.hostname;

  console.log(
    "🌐 BOOKING HOSTNAME:",
    hostname
  );

  /* ======================================
     LOCAL DEVELOPMENT
  ====================================== */

  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1"
  ) {

    return (
      process.env.REACT_APP_TEST_SUBDOMAIN ||
      "saraca"
    );
  }

  /* ======================================
     LOCAL SUBDOMAIN
     
     Example:
     saraca.localhost
  ====================================== */

  if (
    hostname.endsWith(".localhost")
  ) {

    return hostname
      .split(".")[0];
  }

  /* ======================================
     PRODUCTION
     
     Example:
     nexifysolutionyatran.yatranest.in
     
     => nexifysolutionyatran
  ====================================== */

  if (
    hostname.endsWith(".yatranest.in")
  ) {

    return hostname
      .split(".")[0];
  }

  console.warn(
    "⚠️ Unable to determine booking subdomain:",
    hostname
  );

  return null;
};

export default getBookingSubdomain;